import { ConstantItems, getDefaultConfig } from "@constants/shared";
import { isNullOrUndefined } from "util";
import { ReportingParams } from "../reporting/reportingParams";

export class ReportingService {
  /** @ngInject */
  constructor(
    private $http: angular.IHttpService,
    private $window: angular.IWindowService,
    private config: ConstantItems
  ) {}

  private generatePdf(reportingParams: ReportingParams) {
    let config = getDefaultConfig();
    reportingParams.currency = isNullOrUndefined(reportingParams.currency) ? "MUR" : reportingParams.currency

    // If userId is not null or empty, generate the combined clients report for the user:
    if (reportingParams.userId) {
      return this.$http.post(
        `${this.config.reportsUrl}/generate/user`,
        reportingParams,
        config
      );
    }

    // If clientNumber is not null or empty, generate the report for the client:
    if (reportingParams.clientNumber) {
      return this.$http.post(
        `${this.config.reportsUrl}/generate/client`,
        reportingParams,
        config
      );
    }

    // If portfolioIds is not null or empty, generate a report for the selected portfolios:
    if (reportingParams.portfolioIds) {
      return this.$http.post(
        `${this.config.reportsUrl}/generate/selectedPortfolios`,
        reportingParams,
        config
      );
    }
  }

  private getReportUrl(reportKey: string) {
    return this.$http.get(
      `${this.config.reportingUrl}/url/${encodeURIComponent(reportKey)}`
    );
  }

  private openReportInNewTab(url: string) {
    this.$window.open(url, "_blank");
  }

  // To generate a combined clients report for a user: send a userId
  // To generate a report for a single client: send a clientNumber
  // To generate a report for selected portfolios: send a list of portfolioIds
  public generateReport(reportingParams: ReportingParams) {
    return this.generatePdf(reportingParams).then((res) => {
      this.openReportInNewTab(res.data["reportTempURL"]);
    });
  }

  public openReport(reportKey: string) {
    return this.getReportUrl(reportKey).then((res) => {
      this.openReportInNewTab(res.data["tempUrl"]);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/reporting.service.ts